/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarButtons_viewer = {
    readonly isDyoEnabled: boolean | null;
    readonly " $refType": "PdpRespSidebarButtons_viewer";
};
export type PdpRespSidebarButtons_viewer$data = PdpRespSidebarButtons_viewer;
export type PdpRespSidebarButtons_viewer$key = {
    readonly " $data"?: PdpRespSidebarButtons_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_viewer",
  "selections": [
    {
      "alias": "isDyoEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "designYourOwn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"designYourOwn\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'bf4d71a2fa60982a3c7e5728abadae8b';
export default node;
